import { StyleSheet } from '@patternfly/react-styles';
export default StyleSheet.parse(`.pf-l-split{--pf-l-split--m-gutter--MarginRight:var(--pf-global--gutter);display:flex;flex-wrap:nowrap;padding:0;margin:0;}.pf-l-split__item.pf-m-main{flex-grow:1;}.pf-l-split.pf-m-gutter > *:not(:last-child){margin-right:var(--pf-l-split--m-gutter--MarginRight);}`);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/@patternfly/patternfly-next/layouts/Split/split.css.js
// module id = 126
// module chunks = 0